import React from "react";
import "./copyright.css";

const Copyright = () => {
  return (
    <div className="copyright">
      <span>© Copyright 2023 Berat UÇAR</span>
    </div>
  );
};

export default Copyright;
